import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";

const DarkMode = ({ className = "" }) => {
	// Detectar preferencia del sistema
	const prefersDark = window.matchMedia("(prefers-color-scheme: light)").matches;

	// Estado del tema, iniciando con lo guardado en localStorage o la preferencia del sistema
	const [darkMode, setDarkMode] = useState(() => {
		const theme = localStorage.getItem("theme");
		// console.log(prefersDark);
		//  Si el tema guardado en localStorage es "dark", se retorna true
		return theme === "dark" ? true : false;
	});

	// Efecto para aplicar la clase "dark" al <html>
	useEffect(() => {
		if (darkMode) {
			document.documentElement.classList.add("dark");
			localStorage.setItem("theme", "dark");
		} else {
			document.documentElement.classList.remove("dark");
			localStorage.setItem("theme", "light");
		}
	}, [darkMode]);

	return (
		<button
			onClick={() => setDarkMode(!darkMode)}
			className={`p-4 rounded-full text-turquesa transition duration-300 fixed top-0 right-0 z-10 ${className} transition-colors`}
		>
			<FontAwesomeIcon icon={darkMode ? faSun : faMoon} className="w-5 h-5" />
		</button>
	);
};

export default DarkMode;